export default "__VITE_ASSET__D0XH7it$__"